<section class="section section--list-offers-head" *ngIf="result.info">
  <div class="row align-items-end">
    <div class="result-nav row">
      <div class="mobile-button-filter col-6 col-sm-7 d-flex d-lg-none justify-content-between align-items-center"
           *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional'"
           (click)="filtersVisibleEvent.emit()">
        <div class="mobile-button-filter__left">
          <i class="icon icon-right_arrow icon-down"></i>
          Filtruj oferty
        </div>
        <div class="mobile-button-filter__right">
          <i class="icon icon-search"></i>
        </div>
      </div>

      <ng-container *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional'">
      <h3 class="result-nav__count col-6 col-sm-5">{{result.info.countOfResults}} {{result.info.countOfResults | offerWord}}</h3>
      <div *ngIf="newCarsOfferCount !== null && newCarsOfferCount > 0 && initOfferCount != 0" class="col-12 d-block d-lg-none list-top-link mb-3">
        <a [href]="newCarsUrl">Sprawdź dostępne samochody nowe<i class="icon icon-right_arrow"></i></a>
      </div>
      <h3 *ngIf="dealerCode" class="col-12 col-md-auto">Oferty dealera {{result.info.dealerNames[dealerCode | dealerCode]}}</h3>
      <div class="col-12 d-xl-flex">
        <div class="sort">
          <div class="sort__options">
            <div class="sort__label">
              SORTUJ
            </div>
            <div class="sort__option">
            <span class="sort__btn is-active"
                  [ngClass]="{'is-active': sorting==='popular'}"
                  (click)="changeSorting('popular')"
                  data-adobe="content:used:order-by:popular"
            >NAJPOPULARNIEJSZE</span>
            </div>
            <div class="sort__option">
            <span class="sort__btn is-active"
                  [ngClass]="{'is-active': sorting==='new'}"
                  (click)="changeSorting('new')"
                  data-adobe="content:used:order-by:last"
            >NAJNOWSZE</span>
            </div>
            <div class="sort__option">
            <span class="sort__btn is-active"
                  [ngClass]="{'is-active': sorting==='price-asc'}"
                  (click)="changeSorting('price-asc')"
                  data-adobe="content:used:order-by:price-asc"
            >WG CENY ROSNĄCO</span>
            </div>
            <div class="sort__option">
            <span class="sort__btn is-active"
                  [ngClass]="{'is-active': sorting==='price-desc'}"
                  (click)="changeSorting('price-desc')"
                  data-adobe="content:used:order-by:price-desc"
            >WG CENY MALEJĄCO</span>
            </div>
            <div class="sort__option">
            <span class="sort__btn is-active"
                  [ngClass]="{'is-active': sorting==='name-asc'}"
                  (click)="changeSorting('name-asc')"
                  data-adobe="content:used:order-by:name-a"
            >NAZWA A-Z</span>
            </div>
            <div class="sort__option">
            <span class="sort__btn is-active"
                  [ngClass]="{'is-active': sorting==='name-desc'}"
                  (click)="changeSorting('name-desc')"
                  data-adobe="content:used:order-by:name-z"
            >NAZWA Z-A</span>
            </div>
            <div class="sort__option" *ngIf="distanceSortingAvailable">
            <span class="sort__btn is-active"
                  [ngClass]="{'is-active': sorting==='distance-asc'}"
                  (click)="changeSorting('distance-asc')"
                  data-adobe="content:used:order-by:distance-asc"
            >NAJBLIŻEJ</span>
            </div>
          </div>
        </div>
        <div class="views justify-content-end ml-auto mt-3 mt-xl-0">
          <div class="view__options">
            <div class="view__label">
              WIDOK
            </div>
            <div class="view__option text-center" data-adobe="content:used:view-grid" [ngClass]="{'is-active': !horizontalView}" (click)="changeHorizontalView(false)"><i class="icon icon-grid"></i></div>
            <div class="view__option text-center" data-adobe="content:used:view-list" [ngClass]="{'is-active': horizontalView}" (click)="changeHorizontalView(true)"><i class="icon icon-hamburger"></i></div>
          </div>
        </div>
      </div>
      </ng-container>

      <ng-container *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'">
        <div  class="col-6 col-lg-7 pb-3 pb-lg-0 mb-lg-3">

          <div class="title-offer-list">
            <span *ngIf="dealerCode === null">SAMOCHODY DEMONSTRACYJNE</span>
            <span *ngIf="dealerCode !== null">SAMOCHODY DEMONSTRACYJNE<br />{{result.info.dealerNames[dealerCode | dealerCode]}}</span>
          </div>
        </div>
        <h3 class="result-nav__count col-6 col-lg-5"><strong>{{result.info.countOfResults}}</strong> {{result.info.countOfResults | offerWord}}</h3>

        <div class="col-12 d-xl-flex">
          <div class="sort" [ngClass]="{'sort-mobile-dealersite': dealerCode !== null}">
            <div class="mobile-button-show-filter"
                 *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'" (click)="filtersVisibleEvent.emit()">
              WYSZUKAJ
              <div class="btn-arrow-down">
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.8438 9.71915L7.37721 15.8468C7.32856 15.8952 7.27004 15.9338 7.2052 15.9601C7.14035 15.9864 7.07054 16 7 16C6.92945 16 6.85964 15.9864 6.7948 15.9601C6.72996 15.9338 6.67144 15.8952 6.62278 15.8468L0.156246 9.71915C0.0562022 9.62435 -1.66135e-06 9.49577 -1.63685e-06 9.3617C-1.61236e-06 9.22763 0.0562023 9.09906 0.156246 9.00426C0.256289 8.90945 0.391978 8.8562 0.533461 8.8562C0.674944 8.8562 0.810632 8.90945 0.910675 9.00426L6.46112 14.2553L6.46112 0.510639C6.46112 0.37521 6.5179 0.245327 6.61896 0.149564C6.72002 0.0538003 6.85708 1.19893e-06 7 1.22392e-06C7.14292 1.24891e-06 7.27999 0.0538004 7.38104 0.149564C7.4821 0.245327 7.53888 0.37521 7.53888 0.51064L7.53888 14.2553L13.0893 9.00426C13.1894 8.90946 13.3251 8.8562 13.4665 8.8562C13.608 8.8562 13.7437 8.90946 13.8438 9.00426C13.9438 9.09906 14 9.22764 14 9.3617C14 9.49577 13.9438 9.62435 13.8438 9.71915V9.71915Z" fill="#1B1C1B"/>
                </svg>
              </div>
            </div>

            <div class="sort__options" (click)="openOrCloseSortList()">
              <div class="sort__label" *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'">
                SORTUJ
                <div class="btn-arrow-down" [ngClass]="{'btn-arrow-down--open': openedSortList}">
                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8438 9.71915L7.37721 15.8468C7.32856 15.8952 7.27004 15.9338 7.2052 15.9601C7.14035 15.9864 7.07054 16 7 16C6.92945 16 6.85964 15.9864 6.7948 15.9601C6.72996 15.9338 6.67144 15.8952 6.62278 15.8468L0.156246 9.71915C0.0562022 9.62435 -1.66135e-06 9.49577 -1.63685e-06 9.3617C-1.61236e-06 9.22763 0.0562023 9.09906 0.156246 9.00426C0.256289 8.90945 0.391978 8.8562 0.533461 8.8562C0.674944 8.8562 0.810632 8.90945 0.910675 9.00426L6.46112 14.2553L6.46112 0.510639C6.46112 0.37521 6.5179 0.245327 6.61896 0.149564C6.72002 0.0538003 6.85708 1.19893e-06 7 1.22392e-06C7.14292 1.24891e-06 7.27999 0.0538004 7.38104 0.149564C7.4821 0.245327 7.53888 0.37521 7.53888 0.51064L7.53888 14.2553L13.0893 9.00426C13.1894 8.90946 13.3251 8.8562 13.4665 8.8562C13.608 8.8562 13.7437 8.90946 13.8438 9.00426C13.9438 9.09906 14 9.22764 14 9.3617C14 9.49577 13.9438 9.62435 13.8438 9.71915V9.71915Z" fill="#1B1C1B"/>
                  </svg>
                </div>
              </div>

              <ng-container *ngIf="openedSortList">
                <div class="sort__option">
                  <span class="sort__btn is-active"
                        [ngClass]="{'is-active': sorting==='price-asc'}"
                        (click)="changeSorting('price-asc')"
                        data-adobe="content:stocklocator:order-by:price-asc">WG CENY ROSNĄCO</span>
                </div>
                <div class="sort__option">
                  <span class="sort__btn is-active"
                        [ngClass]="{'is-active': sorting==='price-desc'}"
                        (click)="changeSorting('price-desc')"
                        data-adobe="content:stocklocator:order-by:price-desc">WG CENY MALEJĄCO</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
<section class="section section--list-offers-result row" [ngClass]="{'horizontal-view': horizontalView && brandSlug !== 'fiat' && brandSlug !== 'fiat-professional'}">
  <div class="section__bg"></div>
  <ng-container *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional'">
    <app-offer-card class="box-model-card col-12 col-lg-6 col-xl-4" *ngFor="let item of result.list" [item]="item"></app-offer-card>
  </ng-container>
  <ng-container *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'">
    <app-offer-box class="col-6 col-md-4 col-lg-6 col-xl-4" *ngFor="let item of result.list" [item]="item"></app-offer-box>
  </ng-container>
  <loader [visible]="listLoading"></loader>
</section>
<div class="text-center offers-not-found" *ngIf="result.info && result.info.countOfResults == 0">
  <ng-container *ngIf="initOfferCount == 0">Nie znaleziono ofert spełniających kryteria.</ng-container>
  <ng-container *ngIf="initOfferCount != 0">Nie znaleziono ofert spełniających wszystkie wybrane kryteria.</ng-container>

  <div class="w-100" *ngIf="newCarsOfferCount !== null && newCarsOfferCount > 0 && initOfferCount == 0">
    <div class="list-top-link result-top-link">
      <a [href]="newCarsUrl">Sprawdź dostępne samochody nowe<i class="icon icon-right_arrow"></i></a>
    </div>
  </div>
</div>
<section class="section section--list-offers-footer" *ngIf="result.info && result.info.countOfResults > result.list.length">
  <ngb-pagination [collectionSize]="result.info.countOfResults"
                  [page]="result.info.pageNumber"
                  [pageSize]="result.info.offersPerPage"
                  [maxSize]="7"
                  [ellipses]="true"
                  [rotate]="true"
                  (pageChange)="pageChangeEvent($event)"
  >
    <ng-container *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'">
      <ng-template ngbPaginationPrevious>
        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.85106 16.8103L0.19149 8.95805C0.13098 8.89897 0.0828057 8.82791 0.0498887 8.74917C0.0169736 8.67043 1.02383e-07 8.58566 1.01361e-07 8.5C1.0034e-07 8.41434 0.0169736 8.32957 0.0498887 8.25083C0.0828057 8.17209 0.13098 8.10103 0.19149 8.04195L7.85106 0.189729C7.96956 0.0682477 8.13029 1.40265e-07 8.29787 1.39546e-07C8.46546 1.38828e-07 8.62618 0.0682477 8.74468 0.189729C8.86318 0.311211 8.92976 0.475975 8.92976 0.647776C8.92976 0.819576 8.86318 0.984341 8.74468 1.10582L2.18085 7.84565L19.3617 7.84565C19.531 7.84565 19.6933 7.91459 19.813 8.0373C19.9328 8.16002 20 8.32646 20 8.5C20 8.67354 19.9328 8.83998 19.813 8.9627C19.6933 9.08541 19.531 9.15435 19.3617 9.15435L2.18085 9.15435L8.74468 15.8942C8.86318 16.0157 8.92976 16.1804 8.92976 16.3522C8.92976 16.524 8.86318 16.6888 8.74468 16.8103C8.62618 16.9318 8.46546 17 8.29787 17C8.13029 17 7.96956 16.9318 7.85106 16.8103Z" fill="#1B1C1B"/>
        </svg>
      </ng-template>
      <ng-template ngbPaginationNext>
        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.1489 0.189729L19.8085 8.04195C19.869 8.10103 19.9172 8.17209 19.9501 8.25083C19.983 8.32957 20 8.41434 20 8.5C20 8.58566 19.983 8.67043 19.9501 8.74917C19.9172 8.82791 19.869 8.89897 19.8085 8.95805L12.1489 16.8103C12.0304 16.9318 11.8697 17 11.7021 17C11.5345 17 11.3738 16.9318 11.2553 16.8103C11.1368 16.6888 11.0702 16.524 11.0702 16.3522C11.0702 16.1804 11.1368 16.0157 11.2553 15.8942L17.8191 9.15435L0.638298 9.15435C0.46901 9.15435 0.306657 9.08541 0.186953 8.9627C0.0672486 8.83998 -3.63961e-07 8.67354 -3.71547e-07 8.5C-3.79133e-07 8.32646 0.0672486 8.16002 0.186953 8.0373C0.306657 7.91459 0.46901 7.84565 0.638298 7.84565L17.8191 7.84565L11.2553 1.10582C11.1368 0.98434 11.0702 0.819576 11.0702 0.647775C11.0702 0.475975 11.1368 0.31121 11.2553 0.189729C11.3738 0.0682483 11.5345 -5.04191e-07 11.7021 -5.11516e-07C11.8697 -5.18842e-07 12.0304 0.0682482 12.1489 0.189729Z" fill="#1B1C1B"/>
        </svg>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional'">
      <ng-template ngbPaginationPrevious><i class="icon icon-left_arrow"></i></ng-template>
      <ng-template ngbPaginationNext><i class="icon icon-right_arrow pagination__link--next"></i></ng-template>
    </ng-container>
    <ng-template ngbPaginationEllipsis>...</ng-template>
    <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
  </ngb-pagination>
</section>
